<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.notifyHeight()
    // 路由切换后重新上报高度
    this.$router.afterEach(() => {
      this.$nextTick(() => this.notifyHeight())
    })
    // 内容变化时持续上报（处理异步加载内容撑高页面的情况）
    if (typeof ResizeObserver !== 'undefined') {
      this._ro = new ResizeObserver(() => this.notifyHeight())
      this._ro.observe(document.body)
    }
  },
  beforeDestroy() {
    if (this._ro) this._ro.disconnect()
  },
  methods: {
    notifyHeight() {
      const height = document.body.scrollHeight
      // 通知 Shopline 外层 iframe 调整高度
      window.parent.postMessage({ type: 'setHeight', height }, '*')
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}

/* 锁定在 iframe 可视区域内，只有一条滚动条 */
html, body {
  height: 100%;
  overflow: hidden;
}

#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ant-layout {
  flex: 1;
  overflow: hidden;
}

/* 内容区域是唯一的滚动层 */
.ant-layout-content {
  overflow-y: auto;
  overflow-x: hidden;
}

/* 全局统一滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue